// src/pages/Home.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import ThreeRandomCards from "../components/ThreeRandomCards.jsx";
import AddNewCardModal from "../components/AddNewCardModal.jsx";

export default function Home({ onNavigate, user }) {
  const [cardOfTheDay, setCardOfTheDay] = useState(null);
  const [showRandomDeck, setShowRandomDeck] = useState(false); 
  const [addNewCard, setAddNewCard] = useState(false); 
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCardOfTheDay = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}api/data/snapCards?userId=${user.id}`
        );
        const data = await res.json();
        const normalized = data.map((c) => ({
          ...c,
          cardName: c.cardname,
          cardHTML: c.cardhtml,
          cardDesc: c.carddesc,
          cardUser: c.carduser,
          cardCost: c.cardcost,
          cardPower: c.cardpower,
        }));

        if (normalized.length > 0) {
          const today = new Date();
          const seed =
            today.getFullYear() * 10000 +
            (today.getMonth() + 1) * 100 +
            today.getDate();
          const index = seed % normalized.length;
          setCardOfTheDay(normalized[index]);
        }
      } catch (err) {
        console.error("Failed to fetch cards:", err);
      }
    };
    fetchCardOfTheDay();
  }, [user]);

  return (
    <div className="drafts-panel">
      <h1 className="drafts-heading">Welcome to MySnap!</h1>

      {user && (
        <p
          style={{
            color: "rgb(197, 176, 55)",
            textAlign: "center",
            marginBottom: "24px",
          }}
        >
          Welcome back, <strong>{user.mainname}</strong>!
        </p>
      )}

      {cardOfTheDay && (
        <div className="card-of-day">
          <h2 className="results-heading">Card of the Day</h2>
          <div className="card-of-day-box">
            {cardOfTheDay.cardHTML ? (
              <img
                src={cardOfTheDay.cardHTML}
                alt={cardOfTheDay.cardName}
                className="card-of-day-img"
              />
            ) : (
              <div className="card-of-day-placeholder">
                {cardOfTheDay.cardName}
              </div>
            )}
            <p className="card-of-day-desc">{cardOfTheDay.cardDesc}</p>
          </div>
        </div>
      )}

      {/* === Random Deck Starter Button === */}
      <div style={{ textAlign: "center", margin: "32px 0" }}>
        <button
          className="modern-btn"
          onClick={() => setShowRandomDeck(true)}
        >
          Random Deck Starter
        </button>
        <button
          className="modern-btn"
          onClick={() => setAddNewCard(true)}
        >
          Add New Card
        </button>
      </div>

      {/* === Modal Popup === */}
      {showRandomDeck && (
        <ThreeRandomCards onClose={() => setShowRandomDeck(false)} />
      )}

      {addNewCard && (
        <AddNewCardModal
          user={user}
          onClose={() => setAddNewCard(false)}
          onCreated={(createdCard) => {
            // Optional: refresh Card of the Day or show a toast, etc.
            console.log("Created card:", createdCard);
          }}
        />
      )}

      <div className="dual-columns">
        {/* Draft Mode */}
        <div
          className="draft-column"
          onClick={() => navigate("draft")}
          style={{ cursor: "pointer" }}
        >
          
          <h2 className="results-heading">Draft Mode</h2>
          <p>Start a new draft and build your tournament decks.</p>
          <button className="modern-btn" onClick={() => navigate("draft")}>
            Enter Draft
          </button>
        </div>

        {/* Active Tournaments */}
        <div
          className="draft-column"
          onClick={() => navigate("tournament")}
          style={{ cursor: "pointer" }}
        >
          <h2 className="results-heading">Active Tournaments</h2>
          <p>View the tournaments currently going on.</p>
          <button
            className="modern-btn"
            onClick={() => navigate("tournament")}
          >
            View Tournaments
          </button>
        </div>

        {/* Card Stats */}
        <div
          className="draft-column"
          onClick={() => navigate("card-stats")}
          style={{ cursor: "pointer" }}
        >
          <h2 className="results-heading">Card Statistics</h2>
          <p>View what your decks and their performances say about you!</p>
          <button
            className="modern-btn"
            onClick={() => navigate("card-stats")}
          >
            View Stats
          </button>
        </div>
      </div>
      {/* <div>
        <h2>Random MVS Wheel</h2>
        <div>
          <iframe 
            src="https://wheeldecide.com/e.php?c1=Buckets+of+Cram&c2=Cram-Meister&c3=Data+Gathering&c4=Death+By+Thighs&c5=Delta+Chambers&c6=Double+it+ZG&c7=Firey+Surfer&c8=I+Summon+Thee+To+Destroy&c9=ITA+YTKO&c10=Im+Waitiiiing&c11=Its+a+Later+Issue&c12=Low-Power+Card+Lives+Matter&c13=Merging+Tribunal&c14=Morph%E2%80%99s+Magik+Mill&c15=Noir+Amogus&c16=One+Time+Use%2A&c17=Open+the+Gates+for+Morph&c18=Party+Crashers&c19=Phoenix%E2%80%99s+Force&c20=Rip+and+Gamble&c21=STM%3F+MID...&c22=Slippery+Little+Bastard&c23=The+Trifecta&c24=Thick+Friends&c25=We+Hungee&c26=Zoo+on+Fire&c27=ooooWind+Aide+My+Hand&c28=%28Another%29+Morph%27s+Magik+Mill&c29=C%23%2B%2B%2B+%F0%9F%92%BE&c30=Es-cuse-Me&c31=F.A.M.I.L.Y.&c32=Firehair%21%21%21+ICTB&c33=Firehorn&c34=I+See+You%E2%80%A6&c35=I-95&c36=Insert+Here&c37=Introverts&c38=Jump+Around%21+Jump+Around%21&c39=Just+the+Storm+Dick&c40=MB+Firehair&c41=Not+the+Mark+Salesman&c42=Oh%21+Hi+Peni%21&c43=Onburning&c44=Testing+the+Fire&c45=The+Fallen+Firehair&c46=Thickums+%231&c47=Thickums+%232&c48=Transformers&c49=Wiccan+Do+It%21&c50=%28Beta%29+Dead+Zoo&c51=123&c52=And+When+Everything+Costs+6...&c53=Another+One&c54=Car+Crash&c55=Communism&c56=Moira+Benslayer+%F0%9F%90%A7&c57=Muchos+Gracias+Seniora&c58=Symbiote+wont+Merge+%3A%28&c59=What+Da+Sword+Doin%3F&c60=You+Like+to+Move+it+Move+it&c61=Artillery+Unit&c62=BORN+AGAIN%21&c63=Back+in+Black&c64=Discard+MamaCoco&c65=Embrace+Monke&c66=Flying+Spring&c67=Galactus+Losing+Euchre&c68=Hawa+Without+the+Hawa&c69=He-She-We.+3-Power&c70=I+am+Thamnos&c71=Judgement+Day&c72=Kammori+Kahhori&c73=Maximum+Carnage&c74=Maximum+Gambit&c75=Merge+Activate+Merge&c76=Muchas+Gracis+Senior&c77=Noir+Best&c78=Nuclear+Bomb&c79=Open+Up+The+Galaxy&c80=Party+Zombies&c81=Poonstone&c82=Pressurized+Ball&c83=Red+Sun&c84=Repeat+After+Me&c85=Sealed+Fate&c86=She-Hulk+Schlog&c87=Suspicious+Twins&c88=Tax+Collector&c89=The+Golly+of+Zola&c90=The+Government&c91=The+Merge&c92=There+is+a+3-Cost+Amogus&c93=To+Kill+4+Mockingbird&c94=ZCM+Will+Work%21&time=5" 
            width="500" height="500" scrolling="no" frameborder="0">
          </iframe>
        </div>
      </div> */}
    </div>
  );
}
